const listeners = new Set();
let currentClock = null;
let publisherCount = 0;
let fallbackId = null;

function utcDateLikeHeader() {
  return new Date(new Date().toUTCString().slice(0, -4));
}

function stopFallback() {
  if (fallbackId) {
    clearInterval(fallbackId);
    fallbackId = null;
  }
}

function startFallback() {
  if (fallbackId || publisherCount > 0 || listeners.size === 0) {
    return;
  }
  publishCasinoClock(utcDateLikeHeader());
  fallbackId = setInterval(() => {
    publishCasinoClock(utcDateLikeHeader());
  }, 1000);
}

export function publishCasinoClock(date) {
  currentClock = date;
  listeners.forEach((fn) => fn(date));
}

export function beginCasinoClockPublisher() {
  publisherCount += 1;
  stopFallback();
}

export function endCasinoClockPublisher() {
  publisherCount = Math.max(0, publisherCount - 1);
  startFallback();
}

export function subscribeCasinoClock(fn) {
  listeners.add(fn);
  if (currentClock) {
    fn(currentClock);
  }
  startFallback();
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) {
      stopFallback();
    }
  };
}
